if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      /* ---------------------- NEW: modal helpers ---------------------- */
      ensureSizeModal() {
        if (document.getElementById('size-confirm-modal')) return;

        // Read JSON from the script tag
        const settingsEl = document.getElementById('size-modal-settings');
        const settings = settingsEl ? JSON.parse(settingsEl.textContent) : {};

        const eyebrow = settings.eyebrow;
        const title = settings.title;
        const copy = settings.copy;
        const findText = settings.find;
        const addText = settings.add;

        const modal = document.createElement('div');
        modal.id = 'size-confirm-modal';
        modal.setAttribute('aria-hidden', 'true');
        modal.innerHTML = `
          <div class="scm-backdrop"></div>
          <div class="scm-panel" role="dialog" aria-modal="true">
            <button class="scm-close" aria-label="Close">×</button>
            <div class="scm-body">
              <p class="scm-eyebrow">${eyebrow}</p>
              <h3 class="scm-title">${title}</h3>
              <p class="scm-copy">${copy}</p>
            </div>
            <div class="scm-actions">
              <button type="button" class="scm-find">${findText}</button>
              <button type="button" class="scm-add">${addText}</button>
            </div>
          </div>
        `;
        document.body.appendChild(modal);
      }


      showSizeModalAndWait() {
        // Add scroll lock
        function lockScroll() {
          document.documentElement.style.setProperty('overflow', 'hidden', 'important');
          document.body.style.setProperty('overflow', 'hidden', 'important');
          document.body.style.setProperty('position', 'fixed', 'important');
          document.body.style.setProperty('top', `-${window.scrollY}px`, 'important');
          document.body.style.setProperty('width', '100%', 'important');
        }

        // Remove scroll lock
        function unlockScroll() {
          const scrollY = document.body.style.top;
          document.documentElement.style.removeProperty('overflow');
          document.body.style.removeProperty('overflow');
          document.body.style.removeProperty('position');
          document.body.style.removeProperty('top');
          document.body.style.removeProperty('width');
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
        this.ensureSizeModal();
        const modal = document.getElementById('size-confirm-modal');
        modal.setAttribute('aria-hidden', 'false');
        lockScroll();

        return new Promise((resolve) => {
          const cleanup = () => {
            modal.setAttribute('aria-hidden', 'true');
            unlockScroll();
            modal.querySelector('.scm-find').removeEventListener('click', onFind);
            modal.querySelector('.scm-add').removeEventListener('click', onAdd);
            modal.querySelector('.scm-close').removeEventListener('click', onClose);
            modal.querySelector('.scm-backdrop').removeEventListener('click', onClose);
          };
          const onFind = () => {
            cleanup();
            // Prefer size drawer trigger, else EasySize widget
            const opener = document.querySelector('#open-size-drawer');
            if (opener) {
              opener.click();
            } else {
              const ez = document.querySelector('.easysize-widget');
              if (ez) ez.click();
            }
            resolve(false); // do not add
          };
          const onAdd = () => {
            cleanup();
            resolve(true); // proceed with add
          };
          const onClose = () => {
            cleanup();
            resolve(false); // treat closing as "do not add"
          };

          modal.querySelector('.scm-find')?.addEventListener('click', onFind);
          modal.querySelector('.scm-add')?.addEventListener('click', onAdd);
          modal.querySelector('.scm-close')?.addEventListener('click', onClose);
          modal.querySelector('.scm-backdrop')?.addEventListener('click', onClose);
          modal.querySelector('.quiz')?.addEventListener('click', onFind);

        });
      }

      async getTargetProductId(variantId) {
        const elWithPid = this.closest('[data-product-id]') || this;
        if (elWithPid?.dataset?.productId) return Number(elWithPid.dataset.productId);
      }

      async isSecondVariantOfSameProduct(variantId) {
        try {
          const targetVariantId = Number(variantId);
          const targetProductId = await this.getTargetProductId(targetVariantId);

          // If we still don't know the product, don't block the add
          if (!Number.isFinite(targetProductId)) {
            console.warn('Could not resolve product_id for variant', variantId);
            return false;
          }

          const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
          const cart = await cartRes.json();

          const alreadyHasFromProduct = (cart.items || []).some((it) => {
            const cartProductId = Number(it.product_id);
            const cartVariantId = Number(it.variant_id);
            return cartProductId === targetProductId && cartVariantId !== targetVariantId;
          });

          // Debug if needed
          console.log({ targetProductId, targetVariantId, alreadyHasFromProduct, cartItems: cart.items });

          return alreadyHasFromProduct;
        } catch (e) {
          console.warn('Size modal precheck failed', e);
          return false;
        }
      }

      /* -------------------- end modal helpers -------------------- */

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const variantSelects = document.querySelector('variant-selects');
        const isSizeSelected = variantSelects
          ? !!variantSelects.querySelector(
              '.product-form__input--pill input:checked'
            ) ||
            !!variantSelects
              .querySelector('.dropdown-selected p')
              ?.getAttribute('selected')
          : true;

          if(!variantSelects.classList.contains('single-variant')) {
            // check size for different variants products only
            if (!isSizeSelected) {
              const sizeErrorMessage = document.querySelector(
                'variant-selects .size-error'
              );
              if (sizeErrorMessage) sizeErrorMessage.classList.add('error'); // add red error styling
              return;
            } else {
              const sizeErrorMessage = document.querySelector(
                'variant-selects .size-error'
              );
              if (sizeErrorMessage) sizeErrorMessage.classList.remove('error'); // revert to normal black text when valid
            }
          }
          const B_VARIANT_CLASS = 'b-size-popup';
          const isBVariant = () => document.body.classList.contains(B_VARIANT_CLASS);
          const bypassModal = isBVariant() && this.dataset.skipSizeModalOnce === 'true';
          if (bypassModal) {
            this.dataset.skipSizeModalOnce = 'false'; // reset immediately
          } else if (isBVariant()) {
            const formDataPreview = new FormData(this.form);
            const variantId = formDataPreview.get('id');
            const shouldShowModal = await this.isSecondVariantOfSameProduct(variantId);
            if (shouldShowModal) {
              const proceed = await this.showSizeModalAndWait();
              if (!proceed) return;
            }
          }
          this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // Gift card wrapping handle
        let giftCardElement = document.querySelector('[data-gift-wrapping]');
        config.body = formData;
        if(formData.get('product-type') == 'Diverse' && giftCardElement && giftCardElement.checked) {
          // console.log(formData.get('product-type'), giftCardElement, giftCardElement.checked);
          let items = [{
            id: formData.get('id'),
            quantity: formData.get('quantity'),
            properties:{
              _hasGiftWrapping: giftCardElement.dataset.giftWrapping
            }
          }];
          items.push({
            id: giftCardElement.dataset.giftWrapping,
            quantity: formData.get('quantity'),
            properties:{
              _isGiftWrapping: true
            }
          });
          let body = JSON.stringify({
            'sections': this.cart.getSectionsToRender().map((section) => section.id),
            'sections_url': window.location.pathname,
              items: items
          });
          config= { ...fetchConfig(), ...{ body } }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
